import { getJson } from "./apiClient";

export const billingService = {
  getSummary,
};

function getSummary() {
  return getJson("/api/v1/billing/");
}

